import { useEffect, useState } from 'react';
import { updateOrderPurchaseOrder } from '../../services/orders';
import { updateLsPurchaseOrder, uploadDocumentPurchaseOrder } from '../../services/services';
import { displayErrorNotification, displaySuccessNotification } from '../../utils/displayNudosStandardNotifications';
import { NudosButton, NudosTextInput } from '../NudosComponents';
import BillingPurchaseUploader from '../BillingPurchaseUploader/BillingPurchaseUploader';
import { DOCUMENT_TYPE, IDataDocumentPurchaseOrder } from '../../types/purchaseOrderDocument';
import { isFileValid } from '../../utils/validateFiles';
import './PurchaseOrderSection.scss';

const PurchaseOrderSection = ({
  solutionType,
  solutionId,
  reloadDataCallback,
  currentPurchaseOrder,
  purchaseOrderDocumentUrlOrigin
}: IpurchaseOrderSection) => {
  const [purchaseOrder, setPurchaseOrder] = useState<string | undefined | null>(currentPurchaseOrder);
  const [loading, setLoading] = useState(false);
  const [purchaseOrderDocumentUrl, setPurchaseOrderDocumentUrl] = useState<string>();
  const updatePurchaseOrder = async () => {
    if (!solutionId || !solutionType || isNaN(+solutionId)) return;
    setLoading(true);
    try {
      if (solutionType === 'logisticService') {
        const body = { purchaseOrder: purchaseOrder || null, logisticServiceId: +solutionId };
        await updateLsPurchaseOrder(body);
      }

      if (solutionType === 'order') {
        const body = { purchaseOrder: purchaseOrder || null, orderId: +solutionId };
        await updateOrderPurchaseOrder(body);
      }
      reloadDataCallback && reloadDataCallback();
      displaySuccessNotification({ customJSXMessage: <>Se actualizó la órden de compra exitosamente</> });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  const handlePurchaseOrderDocumentUpload = async (file: File) => {
    if (!solutionId) return;
    setLoading(true);
    try {
      const dataDocumentPurchaseOrder: IDataDocumentPurchaseOrder = {
        documentType: solutionType === 'logisticService' ? DOCUMENT_TYPE.LOGISTIC_SERVICE_PO : DOCUMENT_TYPE.ORDER_PO,
        entityId: solutionId
      };
      const bodyJson = JSON.stringify(dataDocumentPurchaseOrder);
      const formData = new FormData();
      const isValid = isFileValid(
        file,
        ['application/pdf', 'image/jpeg'],
        5,
        'El documento debe estar en formato PDF o JPG',
        'El documento no debe superar los 5MB'
      );
      if (!isValid) return;
      formData.append('body', bodyJson);
      formData.append('file', file);
      const response = await uploadDocumentPurchaseOrder(formData);
      if (response) {
        displaySuccessNotification({
          customJSXMessage: <>Se subio el archivo exitosamente</>
        });
        await reloadDataCallback?.();
      }
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (purchaseOrderDocumentUrlOrigin) {
      setPurchaseOrderDocumentUrl(purchaseOrderDocumentUrlOrigin);
    }
  }, [purchaseOrderDocumentUrlOrigin]);

  return (
    <div className="purchaseOrderSection">
      <div className="sectionTitle">Orden de compra (PO)</div>
      <div className="purchaseOrderSectionContainer">
        <BillingPurchaseUploader
          uploadProofOfPurchase={handlePurchaseOrderDocumentUpload}
          proofOfPurchase={purchaseOrderDocumentUrl}
          loading={loading}
        />
        <div className="poFormContainer">
          <NudosTextInput
            componentSize="small"
            placeholder="No. de orden de compra (PO)"
            label="No. de orden de compra (PO)"
            isFilled={!!purchaseOrder}
            defaultValue={currentPurchaseOrder || undefined}
            handleChange={setPurchaseOrder}
          />
          <NudosButton
            customClassName="saveButton"
            customWidth="80px"
            customHeight="18px"
            buttonText="Guardar"
            isButtonLoading={loading}
            handleClick={updatePurchaseOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderSection;

interface IpurchaseOrderSection {
  solutionType: 'order' | 'logisticService';
  solutionId?: number | string;
  reloadDataCallback?: () => void;
  currentPurchaseOrder?: string | null;
  purchaseOrderDocumentUrlOrigin?: string;
}
